import React from 'react';
import PropTypes from 'prop-types';
import TmntHtml from '../../../../tools/TmntHtml';

const StoreHours = ({
  isOpeningSoon, storeHours, additionalStoreMessaging, globalStoreHours, globalOpeningSoon,
}) => (
  <div className="single-store__info-store-hours">
    <h3 className="screen-reader-text" data-propety={globalStoreHours.key}>{globalStoreHours.value}</h3>
    {isOpeningSoon ? (
      <h4 className="store-hours__title" data-property={globalOpeningSoon.key}>{globalOpeningSoon.value}</h4>)
      : (
        <>
          <ul className="store-hour__list-container">
            <StoreHoursList storeHours={storeHours} />
          </ul>
          <p className="single-store__hours-disclaimer">
            <TmntHtml value={additionalStoreMessaging[1].value} />
          </p>
        </>
      )}
  </div>
);

const StoreHoursList = ({ storeHours }) => (
  storeHours.map((storeHour) => (
    <li className="store-hours__row" key={storeHour.day}>
      <span>
        <span className="store-hours__col--date">
          {storeHour.month}
          /
          {storeHour.day}
        </span>
        -
        <span className="store-hours__col--day-of-the-week" data-property={storeHour.weekdayName.key}>
          {storeHour.weekdayName.value}
        </span>
      </span>
      <span className="store-hours__col--hours">
        {storeHour.open12HourFormat}
        -
        {storeHour.close12HourFormat}
      </span>
    </li>
  ))
);

StoreHours.propTypes = {
  isOpeningSoon: PropTypes.bool.isRequired,
  storeHours: PropTypes.arrayOf(PropTypes.shape({
    day: PropTypes.string,
    month: PropTypes.string,
    open12HourFormat: PropTypes.string,
    close12HourFormat: PropTypes.string,
    weekdayName: PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.string,
    }),
  })).isRequired,
  globalStoreHours: PropTypes.shape({
    key: PropTypes.string,
    value: PropTypes.string,
  }).isRequired,
  globalOpeningSoon: PropTypes.shape({
    key: PropTypes.string,
    value: PropTypes.string,
  }).isRequired,
  additionalStoreMessaging: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    value: PropTypes.string,
  })).isRequired,
};

StoreHoursList.propTypes = {
  storeHours: PropTypes.arrayOf(PropTypes.shape({
    day: PropTypes.string,
    month: PropTypes.string,
    open12HourFormat: PropTypes.string,
    close12HourFormat: PropTypes.string,
    weekdayName: PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.string,
    }),
  })).isRequired,
};

export default StoreHours;
